/**
 * @generated SignedSource<<601ced77bca28dc61a4c9283fc353ecb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type latestDiscoveryWidgetSection$data = {
  readonly entityId: string;
  readonly name: string;
  readonly parentSection: string | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "latestDiscoveryWidgetSection";
};
export type latestDiscoveryWidgetSection$key = {
  readonly " $data"?: latestDiscoveryWidgetSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"latestDiscoveryWidgetSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "latestDiscoveryWidgetSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
};

(node as any).hash = "2ee06487c9686428fc90b0adca8efb8c";

export default node;
